export const CARBON_INTENSITY = {
  VERY_HIGH: 'VERY_HIGH',
  HIGH: 'HIGH',
  MODERATE: 'MODERATE',
  LOW: 'LOW',
  VERY_LOW: 'VERY_LOW',
};

export const TEMPERATURE_RANKING = {
  UNAVAILABLE: 'UNAVAILABLE',
  ALIGNED_LOW: 'ALIGNED_LOW',
  ALIGNED: 'ALIGNED',
  MISALIGNED: 'MISALIGNED',
  STRONGLY_MISALIGNED: 'STRONGLY_MISALIGNED',
};

export enum ESGRatingDistributionValue {
  AAA = 'AAA',
  AA = 'AA',
  A = 'A',
  BBB = 'BBB',
  BB = 'BB',
  B = 'B',
  CCC = 'CCC',
  NO_VALUE = 'NoValue',
}

export enum ESGRatingClassification {
  LEADER = 'LEADER',
  AVERAGE = 'AVERAGE',
  LAGGARD = 'LAGGARD',
}

export enum ESGColourDefinition {
  STRONGLY_LOW = '#3662FF',
  VERY_LOW = '#599693',
  LOW = '#84C0BE',
  MODERATE = '#CEE6E5',
  LOW_MODERATE = '#E6F2F2',
  VERY_LOW_MODERATE = '#EED1BE',
  HIGH = '#DEA47C',
  VERY_HIGH = '#CE763B',
  UNAVAILABLE = '#505779',
  UNAVAILABLE_THEME_LIGHT = '#E5E5E5',
  NA = '#7D7D7D',
  TEXT_STRONGLY_ALIGNED = '#336CFA',
  TEXT_ALIGNED = '#2D8080',
  TEXT_MODERATE = '#B95E06',
  TEXT_MISALIGNED = '#D28317',
  TEXT_STRONGLY_MISALIGNED = '#BE3744',
  TEXT_BASE = '#2F2F2F',
  TEXT_BASE_2 = '#494949',
  RANKING_HIGH = '#6BB4B1',
  RANKING_MODERATE = '#DAECEB',
  RANKING_VERY_HIGH = '#E6BA9D',
}

export enum RankingLimit {
  MODERATE = 50,
  HIGH = 74,
}

export enum CarbonIntensityLimit {
  VERY_LOW = 15,
  LOW = 70,
  MODERATE = 250,
  HIGH = 525,
}

export enum ImpliedTemperatureLimit {
  ALIGNED_LOW = 1.5,
  ALIGNED = 2,
  MISALIGNED = 3.2,
}
